import { SegmentedControl } from "@/components/segmentedControl/segmentedControl";
import { TopBarMobile } from "@/components/topBarMobile/topBarMobile";
import { useDocumentsMobile } from "./documentsMobile/useDocumentsMobile";
import ListItemMobile from "@/components/listItemMobile/ListItemMobile";
import { faFile, faFolder } from "@fortawesome/pro-light-svg-icons";
import { translate } from "@/config/translator";
import {
  formatDateFromLang,
  getDateFormatLocale,
  getFileFAIcon,
} from "@/config/utils";
import PspBreadcrumb from "@/components/pspBreadcrumb/PspBreadcrumb";
import { formatDistanceToNow } from "date-fns";
import FilePreviewDialog from "@/components/filePreviewDialog/filePreviewDialog";

export function formatPathUrl(path: string) {
  return `/documents/submitted/${path
    .split("/")
    .slice(2, undefined)
    .map(encodeURIComponent)
    .join("/")}`;
}

export function DocumentsMobile() {
  const {
    lang,
    documentKind,
    documentKindOptions,
    pspDocuments,
    page,
    setPage,
    setTotalPages,
    totalPages,
    useSearchQuery,
    navigate,
    currentStructure,
    decodedPath,
    onDownload,
    currentFilePreview,
    setCurrentFilePreview,
    onOpenPreview,
  } = useDocumentsMobile();

  return (
    <>
      <TopBarMobile header="documents" />
      <div className="p-6 flex flex-col gap-3">
        <SegmentedControl
          fillWidth
          onChange={(value) =>
            value === "submitted"
              ? navigate("/documents/submitted")
              : navigate("/documents/psp")
          }
          options={documentKindOptions}
          value={documentKind}
        />
        <div>
          {documentKind === "submitted" ? (
            <>
              {/* BREADCRUMB */}
              {currentStructure ? (
                <PspBreadcrumb
                  currentPath={decodedPath ?? ""}
                  pathPrefix="documents/submitted"
                />
              ) : (
                <p className="text-font-secondary">
                  {translate("noFiles", lang)}
                </p>
              )}
              {/* FILES / FOLDERS */}
              {currentStructure &&
                "children" in currentStructure &&
                currentStructure.children.map((child) => (
                  <ListItemMobile
                    icon={
                      child.type === "folder"
                        ? faFolder
                        : "mime" in child
                          ? getFileFAIcon(child.mime)
                          : faFile
                    }
                    onClick={
                      child.type === "folder"
                        ? () => navigate(formatPathUrl(child.path))
                        : () => onDownload(child.path)
                    }
                    primaryText={child.name}
                    key={`upload-list-element-${child.path}`}
                    secondaryText={formatDistanceToNow(child.lastEdit, {
                      addSuffix: true,
                      locale: getDateFormatLocale(lang),
                    })}
                  />
                ))}
            </>
          ) : pspDocuments?.length === 0 ? (
            <p className="text-font-secondary">
              {translate("noPspDocuments", lang)}
            </p>
          ) : pspDocuments === undefined ? (
            Array.from({ length: 6 }).map(() => <ListItemMobile />)
          ) : (
            pspDocuments?.map((document) => (
              <ListItemMobile
                primaryText={`${translate(document.docType, lang)} - ${document.year}`}
                secondaryText={formatDateFromLang(
                  new Date(document.createdAt),
                  lang,
                )}
                icon={faFile}
                onClick={() => onOpenPreview(document.id)}
              />
            ))
          )}
        </div>
      </div>
      <FilePreviewDialog
        isOpen={!!currentFilePreview}
        onClose={() => setCurrentFilePreview(null)}
        onDownload={onDownload}
        file={currentFilePreview}
      />
    </>
  );
}
